import { render, staticRenderFns } from "./Rules.vue?vue&type=template&id=26c5481c&scoped=true"
import script from "./Rules.vue?vue&type=script&lang=js"
export * from "./Rules.vue?vue&type=script&lang=js"
import style0 from "./Rules.vue?vue&type=style&index=0&id=26c5481c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26c5481c",
  null
  
)

export default component.exports